<template>
  <q-card class="my-card" style="min-width: 20%">
    <!-- Appointment Card Title -->
    <q-card-section :class="getCardBackground(appointment.status)">
      <div class="text-h6">{{ appointment.customerName }}</div>
      <div class="text-subtitle2">
        {{ mappers.appointmentStatusMapper(appointment.status) }}
      </div>
    </q-card-section>

    <!-- Appointment Informations -->
    <q-list>
      <q-item>
        <q-item-section avatar>
          <q-icon color="primary" name="event" />
        </q-item-section>
        <q-item-section>
          <q-item-label
            >{{ timestuff.humanReadableDate(appointment.date) }}
          </q-item-label>
          <q-item-label caption class="text-italic">Randevu Gunu</q-item-label>
        </q-item-section>
      </q-item>

      <q-item>
        <q-item-section avatar>
          <q-icon color="red" name="schedule" />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{
            timestuff.humanReadableAppointmentTime(
              appointment.start,
              appointment.end
            )
          }}</q-item-label>
          <q-item-label caption class="text-italic">Randevu Saati</q-item-label>
        </q-item-section>
      </q-item>

      <q-item>
        <q-item-section avatar>
          <q-icon color="amber" name="local_movies" />
        </q-item-section>
        <q-item-section>
          <q-item-label>{{
            mappers.appointmentTypeMapper(appointment.type)
          }}</q-item-label>
          <q-item-label caption class="text-italic">Seans Cesidi</q-item-label>
        </q-item-section>
      </q-item>
    </q-list>

    <!-- Appointment Action Buttons -->
    <q-card-actions align="around">
      
      <!-- ReSchedule Appointment Button -->
      <q-btn
        v-if="isReScheduleButton"
        color="amber"
        icon="update"
        @click="reSchedulePrompt = true"
        >Tarih Degistir</q-btn
      >
      <!-- ReSchedule Appointment Form -->
      <q-dialog v-model="reSchedulePrompt">
        <AppointmentReschedule :appointment="appointment" />
      </q-dialog>
      
      <!-- Cancel Appointment Button -->
      <q-btn
        v-if="isCancelButton"
        color="red"
        icon="cancel"
        unelevated
        @click="cancelPrompt = true"
        >Iptal Et</q-btn
      >
      <!-- Cancel Appointment Form -->
      <q-dialog v-model="cancelPrompt">
        <AppointmentCancel :appointment="appointment" />
      </q-dialog>

      <!-- Complete Appointment Button -->
      <q-btn
        v-if="isCompleteButton"
        v-close-popup
        icon="check"
        color="secondary"
        @click="onCompleteAppointment"
        >Tamamlandi</q-btn
      >
    </q-card-actions>
  </q-card>
</template>

<script>
import { useQuasar } from 'quasar'
import { ref, toRefs, inject } from 'vue'
import axios from 'axios'
import AppointmentReschedule from './ReSchedule.vue'
import AppointmentCancel from './Cancel.vue'
import * as eventNames from '../../utils/events'
import * as notify from '../../utils/notification'
import * as mappers from '../../utils/mapper'
import * as timestuff from '../../utils/timetravel'

export default {
  components: {
    AppointmentReschedule,
    AppointmentCancel
  },
  props: {
    appointment: Object,
  },
  setup(props) {
    const $q = useQuasar()
    let { appointment } = toRefs(props)
    const emitter = inject('emitter')

    const isCompleteButton = ref(false)
    const isCancelButton = ref(false)
    const isReScheduleButton = ref(false)
    const reSchedulePrompt = ref(false)
    const cancelPrompt = ref(false)

    if (appointment.value.status === 'PLANNED') {
      isCompleteButton.value = true
      isCancelButton.value = true
      isReScheduleButton.value = true
    }

    function getCardBackground(status) {
      switch (status) {
        case 'PLANNED':
          return 'bg-amber text-white'
        case 'CANCELLED':
          return 'bg-red text-white'
        case 'COMPLETED':
          return 'bg-green text-white'
      }
    }

    return {
      mappers,
      timestuff,
      isCompleteButton,
      isCancelButton,
      isReScheduleButton,
      reSchedulePrompt,
      cancelPrompt,

      getCardBackground,
      onCompleteAppointment() {
        axios
          .post(`/appointments/${appointment.value.id}/complete`)
          .then(() => {
            $q.notify(notify.success('Randevu gerceklesti.'))
            emitter.emit(eventNames.REFRESH_APPOINTMENTS)
          })
          .catch(() => {
            $q.notify(notify.warning('Randevu tamamlanmadi.'))
          })
      }      
    }
  },
}
</script>
